module.exports = __webpack_public_path__ + "static/media/passion.b4625f28.webp";